import React, { JSX } from 'react';
import { CircleCheck, CircleX } from 'lucide-react';

type Props = {
  ok: boolean;
  /** Shown (with a check icon) when ok is true. */
  okLabel: string;
  /** Shown (with an x icon) when ok is false. */
  missingLabel: string;
  title?: string;
};

/** Consistent "is this prerequisite done?" badge — same shape and position across DRAFT-stage cards. */
export function StageReadinessBadge(props: Props): JSX.Element {
  const { ok, okLabel, missingLabel, title } = props;
  return (
    <span
      className={[
        'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap',
        ok
          ? 'border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-700/60 dark:bg-emerald-950/40 dark:text-emerald-100'
          : 'border-rose-300 bg-rose-50 text-rose-800 dark:border-rose-700/60 dark:bg-rose-950/40 dark:text-rose-100',
      ].join(' ')}
      title={title ?? (ok ? okLabel : missingLabel)}
    >
      {ok ? (
        <CircleCheck className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} aria-hidden />
      ) : (
        <CircleX className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} aria-hidden />
      )}
      {ok ? okLabel : missingLabel}
    </span>
  );
}
